<template>
  <el-menu
    class="el-nav"
    text-color="#fff"
    background-color="#20222A"
    :collapse="isCollapse"
    :router="true"
  >
    <el-submenu v-for="(item,index) in menu" :key="index" :index="(index + 1) + ``">
      <template slot="title">
        <i :class="{'el-icon-platform-eleme': item.name===`网站管理`,'el-icon-pie-chart': item.name===`扫码收费`,'el-icon-orange': item.name===`菜单管理`,'el-icon-setting': item.name===`系统管理`}"></i>
        <span slot="title">{{ item.name }}</span>
      </template>
      <el-menu-item v-for="(child,jdex) in item.childList" :key="jdex" :index="(index+1) + `-` + (jdex+1)" :route="child.route">{{ child.name }}</el-menu-item>
      <!-- <el-menu-item index="1-2" route="/Main/news/edit">新闻编辑</el-menu-item> -->
    </el-submenu>
    <!-- <el-submenu index="3">
      <template slot="title">
        <i class="el-icon-pie-chart"></i>
        <span slot="title">扫码收费</span>
      </template>
      <el-menu-item index="3-1" route="/Main/payType">收费类型</el-menu-item>
      <el-menu-item index="3-2" route="/Main/payItem">收费项目</el-menu-item>
      <el-menu-item index="3-3" route="/Main/order">收费记录</el-menu-item>
    </el-submenu>
    <el-submenu index="4">
      <template slot="title">
        <i class="el-icon-orange"></i>
        <span slot="title">菜单管理</span>
      </template>
      <el-menu-item index="4-1" route="/Main/mp-menu">公众号菜单</el-menu-item>
    </el-submenu>
    <el-submenu index="2">
      <template slot="title">
        <i class="el-icon-setting"></i>
        <span slot="title">系统管理</span>
      </template>
      <el-menu-item index="2-1" route="/Main/user">员工管理</el-menu-item>
      <el-menu-item index="2-2" route="/Main/role">角色权限</el-menu-item>
    </el-submenu>-->
  </el-menu>
</template>

<script>
export default {
  name: "el-nav",
  data() {
    return {
      coll: this.isCollapse,
      menuList: this.menu
    };
  },
  props: {
    isCollapse: {
      type: Boolean,
      default: () => {
        return false;
      }
    },
    menu: {
      type: Array,
      default: null
    }
  },
  methods: {},
  watch: {
    coll(n, o) {
      this.$emit("update:isCollapse", n);
    },
    isCollapse(n) {
      this.isCollapse = n;
    }
  },
  mounted(){
    console.log(this.menuList)
  }
};
</script>

<style>
.el-nav {
  border: none;
}
.el-nav:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
}
</style>


// WEBPACK FOOTER //
// src/components/el-nav.vue